import { Observable } from 'rxjs/Observable';
import { User, UserRoleResponse, UserType } from '../../models/user';
import { permissionRules } from '../../permissions-rules';
import { NgxPermissionsService } from 'ngx-permissions';
import 'rxjs/add/operator/map';
import * as Sentry from '@sentry/browser';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthorizeService } from '../services/authorize.service';
import { UserService } from '../services/user.service';
import { ForgotPasswordService } from '../services/forgot-password.service';
import { ObjectUtils } from '../utils/object.utils';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FeaturePermission } from '../../models/influencer/feature-permission';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CommunicationService } from '../services/communication/communication.service';
import { InfluencerService } from '../services/influencer/influencer.service';
import { AppSettings } from '../utils/app-settings';
import { CommonConstant } from '../app.constants';
import { DateUtils } from '../utils/date.utils';
import { CacheService } from '../services/cache/cache.service';
import { catchError } from 'rxjs/operators';
import { WebUtils } from '../utils/web.utils';
import { CompanyStatus } from '../../models/common';
var AuthService = /** @class */ (function () {
    function AuthService(permissionsService, authService, userService, forgotPasswordService, communicationService, influencerService, cacheService, router) {
        this.permissionsService = permissionsService;
        this.authService = authService;
        this.userService = userService;
        this.forgotPasswordService = forgotPasswordService;
        this.communicationService = communicationService;
        this.influencerService = influencerService;
        this.cacheService = cacheService;
        this.router = router;
        this.isAcceptTermsAndConditionSubject = new BehaviorSubject(true);
        this.influencerFeaturePermissionsSubject = new BehaviorSubject(null);
        this.CAMPAIGN_INVITATION_LINK_REG = new RegExp(/dashboard\/campaigns\/\d+\/new\?inviteToken=\w+/i);
        this.CONTACT_PERMISSION_REQUEST_LINK_REG = new RegExp(/dashboard\/contact-permission\?accessToken=\w+/i);
        var currentUser = ObjectUtils.parseJSON(localStorage.getItem('user'));
        if (currentUser !== null && currentUser.token) {
            this.user = currentUser;
            this.permissionsService.flushPermissions();
            this.permissionsService.addPermission(this.user.permissions);
        }
    }
    AuthService.prototype.isAuth = function () {
        return ObjectUtils.parseJSON(localStorage.getItem('user')) !== null;
    };
    AuthService.prototype.getUser = function () {
        return ObjectUtils.parseJSON(localStorage.getItem('user')) || new User();
    };
    AuthService.prototype.getInfluencerChannelAuthorizationLocalData = function () {
        return ObjectUtils.parseJSON(localStorage.getItem(CommonConstant.CHANNEL_AUTHORIZATION_DATA));
    };
    AuthService.prototype.removeInfluencerChannelAuthorizationLocalData = function () {
        localStorage.removeItem(CommonConstant.CHANNEL_AUTHORIZATION_DATA);
    };
    AuthService.prototype.saveInfluencerChannelAuthorizationDataOnLocal = function (authChannelData) {
        localStorage.setItem(CommonConstant.CHANNEL_AUTHORIZATION_DATA, JSON.stringify(authChannelData));
    };
    AuthService.prototype.saveAuthorizedChannelOnLocal = function (authorizedChannelId) {
        var authChannels = ObjectUtils.parseJSON(sessionStorage.getItem(CommonConstant.CHANNEL_AUTHORIZATION_DATE));
        if (!authChannels) {
            authChannels = authorizedChannelId;
        }
        else {
            authChannels = authChannels + "," + authorizedChannelId;
        }
        sessionStorage.setItem(CommonConstant.CHANNEL_AUTHORIZATION_DATE, JSON.stringify(authChannels));
    };
    AuthService.prototype.removeIgChannelAuthorizationTimeOnLocal = function () {
        sessionStorage.removeItem(CommonConstant.CHANNEL_AUTHORIZATION_DATE);
    };
    AuthService.prototype.hasAuthorizedIgChannel = function (authorizedChannelId) {
        var authorizeChannels = sessionStorage.getItem(CommonConstant.CHANNEL_AUTHORIZATION_DATE);
        if (!authorizeChannels) {
            return false;
        }
        return authorizeChannels.indexOf(authorizedChannelId) >= 0;
    };
    AuthService.prototype.getPermissions = function (role) {
        var permissions = [];
        var type = role || UserType.GUEST;
        var permissionsKeys = Object.keys(permissionRules);
        for (var _i = 0, permissionsKeys_1 = permissionsKeys; _i < permissionsKeys_1.length; _i++) {
            var key = permissionsKeys_1[_i];
            if (permissionRules[key][type] === true) {
                permissions.push(key);
            }
        }
        return permissions;
    };
    AuthService.prototype.normalizeUserType = function (role, company) {
        switch (role) {
            case UserRoleResponse.ADMINISTRATOR: {
                return UserType.ADMIN;
            }
            case UserRoleResponse.ANALYST: {
                return UserType.ANALYST;
            }
            case UserRoleResponse.USER: {
                if (company) {
                    if (company.advertiser === true) {
                        return UserType.ADVERTISER;
                    }
                    if (company.influencer === true) {
                        return UserType.INFLUENCER;
                    }
                    if (company.network === true) {
                        return UserType.NETWORK;
                    }
                }
                return UserType.AGENCY;
            }
            default:
                return UserType.GUEST;
        }
    };
    AuthService.prototype.mapUserData = function (user) {
        if (!this.user) {
            this.user = new User();
        }
        this.user.data = user.data;
        this.user.email = user.data.email;
        this.user.type = this.normalizeUserType(user.data.role.name, user.data.company);
        this.user.companyId = user.data.company.id;
        this.user.companyName = user.data.company.name;
        this.user.fullName = user.data.fullName;
        this.user.createdAt = user.data.createdAt;
        this.user.permissions = this.getPermissions(this.user.type);
        this.permissionsService.addPermission(this.user.permissions);
        if (user.data.token) {
            this.user.token = user.data.token;
        }
        localStorage.setItem('user', JSON.stringify(this.user));
        this.userService.setIsSsoUser(user.data.isSsoUser);
        this.permissionsService.flushPermissions();
        this.permissionsService.addPermission(this.user.permissions);
    };
    AuthService.prototype.getUserData = function (success, failed) {
        var _this = this;
        return this.userService.getCurrentUserInfo().subscribe(function (user) {
            // update user
            _this.user.data = user.data;
            _this.user.email = user.data.email;
            _this.user.type = _this.normalizeUserType(user.data.role.name, user.data.company);
            _this.user.companyId = user.data.company.id;
            _this.user.companyName = user.data.company.name;
            _this.user.fullName = user.data.fullName;
            _this.user.createdAt = user.data.createdAt;
            _this.user.hasBilling = user.data.company.hasBilling;
            _this.user.permissions = _this.getPermissions(_this.user.type);
            _this.permissionsService.addPermission(_this.user.permissions);
            Sentry.configureScope(function (scope) {
                scope.setUser({
                    id: _this.user.data.id,
                    name: _this.user.data.fullName,
                    email: _this.user.data.email,
                    company: _this.user.data.company.name,
                    type: _this.user.type
                });
            });
            localStorage.setItem('user', JSON.stringify(_this.user));
            _this.userService.setIsSsoUser(user.data.isSsoUser);
            _this.permissionsService.flushPermissions();
            _this.permissionsService.addPermission(_this.user.permissions);
            if (success) {
                success(user);
            }
        }, function (err) {
            if (failed) {
                failed(err);
            }
        });
    };
    AuthService.prototype.forgotPassword = function (email, success, failed) {
        return this.forgotPasswordService.forgotPassword(email, environment.hostName).subscribe(success, failed);
    };
    AuthService.prototype.login = function (username, password, success, failed) {
        var _this = this;
        return this.authService.authorizeUser(username, password).subscribe(function (data) {
            var token = data.Authorization;
            if (token) {
                _this.saveAuthTokenInLocal(token, username);
                if (success) {
                    success(data);
                }
            }
            else {
                return Observable.throw('Missing token');
            }
        }, function (err) {
            WebUtils.reportErrorToSentry('Login error', err);
            if (failed) {
                failed(err);
            }
        });
    };
    AuthService.prototype.saveAuthTokenInLocal = function (token, username) {
        if (!token) {
            return;
        }
        this.user = new User();
        this.user.email = username;
        this.user.token = token;
        localStorage.setItem('user', JSON.stringify(this.user));
    };
    AuthService.prototype.loginByToken = function (token, activeAccount) {
        var _this = this;
        return this.userService.authorizeUserByToken(token).map(function (res) {
            if (!res) {
                return false;
            }
            _this.mapUserData(res);
            if (!_this.userService.getCompanyId()) {
                // this.userService.setActiveCompany([{id: activeAccount, name: 'PDF user'}]);
                var company = res.data.company;
                console.log("company id: " + company.id + " - name: " + company.name);
                _this.userService.setActiveCompany(undefined, {
                    id: activeAccount ? activeAccount : company.id,
                    name: company ? company.name : 'PDF user',
                    inactive: _this.isCustomerStatusInactive(company.customerStatus)
                });
            }
            return true;
        });
    };
    AuthService.prototype.loginByInviteToken = function (inviteToken, campaignId, activeAccount) {
        var _this = this;
        return this.userService.authorizeUserByInviteToken(inviteToken, campaignId).pipe(catchError(function (err) {
            _this.router.navigate(['access-denied']);
            return Observable.of(false);
        })).map(function (res) {
            if (!res) {
                return false;
            }
            _this.mapUserData(res);
            if (!_this.userService.getCompanyId()) {
                // this.userService.setActiveCompany([{id: activeAccount, name: 'PDF user'}]);
                var company = res.data.company;
                console.log("company id: " + company.id + " - name: " + company.name);
                _this.userService.setActiveCompany(undefined, {
                    id: activeAccount ? activeAccount : company.id,
                    name: company ? company.name : 'PDF user',
                    inactive: _this.isCustomerStatusInactive(company.customerStatus)
                });
            }
            return true;
        });
    };
    /**
     * check if account is influencer or not
     * @param companyId
     * @returns {Observable<boolean>}
     */
    AuthService.prototype.authInfluencerFromServer = function (companyId, url) {
        var _this = this;
        return this.userService.loadInfluencerInfoByCompanyId(companyId).map(function (res) {
            if (!res) {
                return _this.isAccessingLandingPage(url);
            }
            _this.userService.addInfluencerInfo(res);
            _this.checkFeaturePermission(res.id, companyId);
            return true;
        });
    };
    AuthService.prototype.checkFeaturePermission = function (influencerId, companyId) {
        var _this = this;
        var observerRequests = forkJoin(this.checkConversationPermission(companyId), this.checkCampaignPermission(influencerId));
        observerRequests.subscribe(function (_a) {
            var res1 = _a[0], res2 = _a[1];
            var featurePermission = new FeaturePermission(res2, res1);
            _this.influencerFeaturePermissionsSubject.next(featurePermission);
        });
    };
    AuthService.prototype.checkCampaignPermission = function (influencerId) {
        var data = {
            influencer_id: influencerId,
            page: 1,
            page_size: 10
        };
        if (AppSettings.isDisableCampaign()) {
            return Observable.of(false);
        }
        return this.influencerService.getCampaignListOfInfluencer(data).map(function (res) { return Array.isArray(res) && res.length > 0; });
    };
    AuthService.prototype.checkConversationPermission = function (companyId) {
        if (AppSettings.isDisableChat()) {
            return Observable.of(false);
        }
        return this.communicationService.fetchConservationList(companyId, CommonConstant.DEFAULT_CONVERSATION_OFFSET, DateUtils.now())
            .map(function (res) { return Array.isArray(res.conversations) && res.conversations.length > 0; });
    };
    AuthService.prototype.logout = function () {
        this.resetUserData();
        var isSsoUser = this.userService.isSsoUser;
        this.userService.clearIsSsoUser();
        if (isSsoUser) {
            WebUtils.navigateToMmiLogoutPage();
            return;
        }
        this.router.navigate(["/login"]);
    };
    AuthService.prototype.resetUserData = function () {
        Sentry.configureScope(function (scope) {
            scope.setUser({});
        });
        localStorage.removeItem('user');
        this.userService.resetActiveAccount();
        this.userService.clearAdvertiserData();
        this.userService.clearCampaignLastViewTime();
    };
    AuthService.prototype.updateResetPassEmail = function (email) {
        this.emailToResetPassword = email;
    };
    Object.defineProperty(AuthService.prototype, "resetPasswordEmail", {
        get: function () {
            return this.emailToResetPassword;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "termsAndConditionObserver", {
        get: function () {
            return this.isAcceptTermsAndConditionSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.haveAcceptedTermAndCondition = function () {
        this.isAcceptTermsAndConditionSubject.next(true);
    };
    AuthService.prototype.needAcceptedTermAndCondition = function () {
        this.isAcceptTermsAndConditionSubject.next(false);
    };
    AuthService.prototype.updateUser = function (title) {
        var user = this.getUser();
        user.data.userTitle = title;
        localStorage.setItem('user', JSON.stringify(user));
    };
    Object.defineProperty(AuthService.prototype, "influencerFeaturePermission", {
        get: function () {
            return this.influencerFeaturePermissionsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.isEnableCampaign = function () {
        var featurePermission = this.influencerFeaturePermissionsSubject.value;
        if (featurePermission) {
            return Observable.of(featurePermission.enableCampaign);
        }
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            return this.checkCampaignPermission(currentInfluencer.id);
        }
        return Observable.of(false);
    };
    AuthService.prototype.isAccessingLandingPage = function (url) {
        return this.CAMPAIGN_INVITATION_LINK_REG.test(url) || this.CONTACT_PERMISSION_REQUEST_LINK_REG.test(url);
    };
    AuthService.prototype.isCustomerStatusInactive = function (customerStatus) {
        return customerStatus === CompanyStatus.BLOCKED
            || customerStatus === CompanyStatus.CHURNED;
    };
    return AuthService;
}());
export { AuthService };



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts.pre-build-optimizer.js